import React, { useEffect, useState, useContext } from "react"
import {
  Box, Flex, Text, Container, Heading, Table, Tbody, Td, Tr, Thead, Link, Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react"
import { Grid, Icon, Button } from "@chakra-ui/react"
import { IconButton } from "@chakra-ui/react"
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons"
import { RiMastercardFill } from "react-icons/ri"
import Card from "../../../components/card/Card"
import CardBody from "../../../components/card/CardBody"
import CardHeader from "../../../components/card/CardHeader"
import IconBox from "../../../components/icons/IconBox"
import reviewImg from "../../../public/img/reviewsimg.png"
import starImg from "../../../public/img/starimg.png"
import listingImg from "../../../public/img/listing.png"
import rankImg from "../../../public/img/rankimg.png"
import ButtonPrimary from "../../../components/buttons/PrimaryButton"
import dynamic from "next/dynamic"
import styles from "../../../styles/dashBoard.module.css"
import Image from "next/image"
import Client from "../../../ApolloClient"
import moment from "moment"
import ProgressBar from "../../../components/progress/ProgressBar"
import { DomainDispatchContext, DomainNameDispatchContext } from "../../../components/context/DomainContext"
import { ContextProvider } from "../../../components/context/ContextProvider"
import { useRouter } from "next/router"
import SkeletonTable from "../../../components/tables/SkeletonTable"
import defaultImage from "../../../public/img/ImgDefault.png"
import { orderBy } from "lodash"
import { ExternalLinkIcon, RepeatIcon } from "@chakra-ui/icons"
import Meta from "../../../components/meta/Meta"
import { arrayFilter, isClientSide, nullValidations, replaceUrlString, retrieveSubScription } from "../../../utils/Utils"
import { REFRESH_SELLER_DATA } from "../../../graphql/mutations"
import { SELLER_DETAILS_AND_ALL_DOMAIN } from "../../../graphql/queries"
import { install } from "resize-observer"
import { useAuth } from "../../../components/context/Auth"
import NextLink from "next/link"
import Script from "next/script"

if (isClientSide()) {
  // Install polyfill for issues in older iOS
  // see issue https://github.com/apexcharts/apexcharts.js/issues/2862
  install()
}
const Chart = dynamic(() => import("react-apexcharts"), {
  ssr: false,
})

const DonutChart = dynamic(
  () => import("../../../components/charts/DonutChart"),
  { ssr: false }
)

export default function DashBoard({ sellerId, code, name, data }) {
  const router = useRouter()
  const [sellerRouteId, setSellerRouteId] = useState(sellerId)
  const { isSignedIn } = useAuth()
  if (sellerId != sellerRouteId) {
    setSellerRouteId(sellerId)
  }
  const [subscriptionDetails, setSubscriptionDetails] = useState()
  const [subscriptionFeatures, setSubscriptionFeatures] = useState()
  const [progressLoad, setProgressLoad] = useState(false)
  const [state, setState] = useState({
    series: [{
      data: []
    }],
    options: {
      chart: {
        height: 350,
        type: "bar",
        toolbar: {
          show: true,
          tools: {
            download: false
          }
        },
      },
      title: {
        text: "Monthly Reviews (Last 12 Months)",
        align: "center",
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize: "14px",
          fontWeight: "bold",
          fontFamily: undefined,
          color: "#263238"
        },
      },
      tooltip: {
        enabled: true,
        enabledOnSeries: undefined,
        shared: true,
        followCursor: false,
        intersect: false,
        inverseOrder: false,
        fillSeriesColor: true,
        theme: false,
        style: {
          fontSize: "12px",
          fontFamily: undefined,
          colors: "white"
        },
        onDatasetHover: {
          highlightDataSeries: false,
        },
        yaxis: {
          show: false,
          title: {
            formatter: (seriesName) => seriesName,
          },
        },
        marker: {
          show: false,
        },
        fixed: {
          enabled: false,
          position: "topRight",
          offsetX: 0,
          offsetY: 0,
        },
      },
      colors: ["#ab47bc", "#ab47bc", "#ab47bc", "#ab47bc", "#ab47bc", "#ab47bc"],
      plotOptions: {
        bar: {
          columnWidth: "45%",
          distributed: true,
          dataLabels: {
            orientation: "horizontal",
            position: "top" // bottom/center/top
          }
        }
      },
      dataLabels: {
        enabled: false,
        formatter: function (val, opt) {
          return `${opt}k`
        },
        style: {
          colors: ["red"]
        },
        offsetY: -25,
      },
      legend: {
        show: false
      },
      yaxis: [
        {
          labels: {
            formatter: function (value) {
              return value?.toLocaleString()
            }
          },
        },
      ],
    },
  })
  const [summery, setSummery] = useState([])
  const [donutchartSeries, setDonutchartSeries] = useState([])
  const [logo, setLogo] = useState(defaultImage)
  const [donutChartTable, setDonutChartTable] = useState(false)
  const [donutchartOptionscharts, setDonutchartOptionscharts] = useState([])
  const [loadStatus, setLoadStatus] = useState(false)
  const [finalData, setFinalData] = useState(data)
  const domainDispatchContextVal = useContext(DomainDispatchContext)
  const domainNameDispatchContextVal = useContext(DomainNameDispatchContext)
  const [loading, setLoading] = useState(true)
  const [signedIn, setSignedIn] = useState(false)

  const signedInModalOpen = () => {
    setSignedIn(true)
  }

  const signedInModalClose = () => {
    setSignedIn(false)
  }

  const refresh = async (sellerCode, sellerId) => {
    if (subscriptionDetails?.subscriptionData === null || !isSignedIn()) {
      signedInModalOpen()
    } else {
      let idSeller = sellerId.split("-")?.length > 1 ? sellerId.split("-")[1] : 0
      setProgressLoad(true)
      try {
        const res = await Client.mutate({
          mutation: REFRESH_SELLER_DATA,
          variables: {
            domainCode: sellerCode,
            sellerId: idSeller
          }
        })
        if (res?.data?.createSeller?.seller) {
          setFinalData(res?.data?.createSeller)
        }
        setLoadStatus(!loadStatus)
        if (res?.data) {
          setProgressLoad(false)
        }
      } catch (error) {
        setProgressLoad(false)
      }

    }

  }
  const oderbyBrand = (brands) => {

    const orderByCount = brands
    orderByCount.sort((a, b) => (a.productCountPct < b.productCountPct) ? 1 : -1)
    let returnformat = ""
    orderByCount.slice(0, 3).map((item, indx) => { returnformat += item.brand + ", " })
    return returnformat.replace(/\s+$/, "").replace(/(^,)|(,$)/g, "") + "."
  }
  const oderbyCategories = (categories) => {

    const orderByCount = categories
    orderByCount.sort((a, b) => (a.category.name < b.category.name) ? 1 : -1)
    let returnformat = ""
    orderByCount.slice(0, 3).map((item, indx) => { returnformat += item.category.name + ", " })
    return returnformat.replace(/\s+$/, "").replace(/(^,)|(,$)/g, "")
  }
  useEffect(() => {
    try {
      if (data) {
        setLoading(false)
        setFinalData(data)
        localStorage.setItem("countryCode", data?.seller?.domain?.code ? data?.seller?.domain?.code : code)
        localStorage.setItem("countryName", data?.seller?.domain?.name ? data?.seller?.domain?.name : name)
        domainDispatchContextVal({ code: data?.seller?.domain?.code ? data?.seller?.domain?.code : code })
        domainNameDispatchContextVal({ name: data?.seller?.domain?.name ? data?.seller?.domain?.name : name })
      }
    } catch (e) {
      setLoading(false)
    }

  }, [data])


  const getSubscription = async () => {
    if (isSignedIn()) {
      const data = await retrieveSubScription()
      const sellerStatsfeatures = data?.subscriptionFeatures?.filter(item => Object.keys(item)[0] === "SELLER_STATS" ? item[Object.keys(item)[0]] : "")
      if (sellerStatsfeatures !== undefined) {
        setSubscriptionFeatures(sellerStatsfeatures[0][Object.keys(sellerStatsfeatures[0])[0]])
      }
      setSubscriptionDetails(data)
    }
  }

  // checking the country from URL and context hook are same
  // if not updating the local storage and context hook
  useEffect(() => {
    getSubscription()
    if (code) {
      if (localStorage.hasOwnProperty("countryCode")) {
        if (localStorage.getItem("countryCode") != code) {
          localStorage.setItem("countryCode", code)
          localStorage.setItem("countryName", name)
          domainDispatchContextVal({ code: code })
          domainNameDispatchContextVal({ name: name })
        }
      }
    }
  }, [])

  // const { loading, error, data } = useQuery(getSellerDetails)

  const revenueCount = (rank, styleStat) => {
    let rankLabel = ""
    switch (true) {
      case (rank <= 10):
        rankLabel = "Top 10"
        break
      case (rank <= 100):
        rankLabel = "Top 100"
        break
      case (rank <= 1000):
        rankLabel = "Top 1,000"
        break
      case (rank <= 10000):
        rankLabel = "Top 10,000"
        break
      case (rank <= 100000):
        rankLabel = "Top 100,000"
        break
      case (rank > 100000):
        rankLabel = "Top 100,000+"
        break
      default:
        rankLabel = ""
    }
    return (
      <Text className={styleStat ? styles.IcontextContent : ""}>
        {rankLabel}
      </Text>
    )
  }
  const revenueCountMeta = (rank, styleStat) => {
    let rankLabel = ""
    switch (true) {
      case (rank <= 10):
        rankLabel = "Top 10"
        break
      case (rank <= 100):
        rankLabel = "Top 100"
        break
      case (rank <= 1000):
        rankLabel = "Top 1,000"
        break
      case (rank <= 10000):
        rankLabel = "Top 10,000"
        break
      case (rank <= 100000):
        rankLabel = "Top 100,000"
        break
      case (rank > 100000):
        rankLabel = "Top 100,000+"
        break
      default:
        rankLabel = ""
    }
    return rankLabel
  }
  const routePage = (id, name, sellerCode) => {
    let sellerId = id.split("-")?.length > 1 ? id.split("-")[1] : 0
    if (sellerId != null || sellerId != undefined) {
      router.push({
        pathname: `/sellers/${sellerCode}/${sellerId}/${replaceUrlString(name)}`
      })
    }
  }

  const roundSalesEstimate = (num) => {
    return Math.round(num / 1000) * 1000
  }

  const roundOrdersEstimate = (num) => {
    return Math.round(num / 100) * 100
  }

  useEffect(() => {
    setLogo(finalData?.seller?.info?.logoImage ? "https://images-na.ssl-images-amazon.com/images/I/" + finalData?.seller?.info?.logoImage : defaultImage)
    localStorage.setItem("sellerName", nullValidations(finalData?.seller?.name))
    let category = []
    for (let i = 0; i < finalData?.seller?.categories.length; i++) {
      finalData?.seller?.categories[i]?.category?.name ==
        Boolean(finalData?.seller?.categories[i]?.category?.name.charAt(0).match(/[a-zA-Z]/))
        && category.length < 2
        && category.push(finalData?.seller?.categories[i]?.category?.name)
    }
    let sellerDomain = nullValidations(finalData?.seller?.info?.country?.name)
    let sellerState = nullValidations(finalData?.seller?.info?.state)
    // data for summary table
    let summeryData = [
      {
        "colFirst": "Seller Name",
        "colSecond": nullValidations(finalData?.seller?.name)
      },
      {
        "colFirst": "Marketplace",
        "colSecond": nullValidations(finalData?.seller?.domain?.name)
      },
      {
        "colFirst": "Seller Reputation",
        "colSecond": finalData?.seller?.stats?.rank12m && revenueCount(nullValidations(finalData?.seller?.stats?.rank12m), false)
      },
      {
        "colFirst": "Sales Estimate (12m) ",
        "colSecond": finalData?.seller?.stats?.salesEst12m ? nullValidations(finalData.seller.domain.currencySymbol ? finalData.seller.domain.currencySymbol + roundSalesEstimate(finalData?.seller?.stats?.salesEst12m)?.toLocaleString() : roundSalesEstimate(finalData?.seller?.stats?.salesEst12m)?.toLocaleString()) : "-"
      },
      {
        "colFirst": "Orders Estimate (12m)",
        "colSecond": finalData?.seller?.stats?.ordersEst12m ? nullValidations(roundOrdersEstimate(finalData?.seller?.stats?.ordersEst12m)?.toLocaleString()) : "-"
      },
      {
        "colFirst": "FBA Seller?",
        "colSecond": finalData?.seller?.hasFba != undefined ? finalData?.seller?.hasFba ? "Yes" : "No" : ""
      },
      {
        "colFirst": "Top Categories",
        "colSecond": arrayFilter(finalData?.seller?.categories, "category", "desc"),
        "CategoriesId": nullValidations(finalData?.seller?.categories)
      },
      {
        "colFirst": "Top Brands",
        "colSecond": nullValidations(arrayFilter(finalData?.seller?.brands, "brand", "desc"))
      },
      {
        "colFirst": "Location",
        "colSecond": sellerState != "" ? `${sellerState}, ${sellerDomain}` : sellerDomain
      },
      {
        "colFirst": "Reviews (last 30d)",
        "colSecond": nullValidations(finalData?.seller?.stats?.reviews1m?.toLocaleString())
      }
    ]
    if (subscriptionDetails?.subscriptionData === null || !isSignedIn()) {
      summeryData.splice(3, 2)
      setSummery(summeryData)
    }
    else {
      setSummery(summeryData)
    }

    let arrMonthYear = []
    let arrSumValue = []
    if (finalData?.seller?.timeSeries?.length > 0) {
      finalData?.seller?.timeSeries?.map((item, index) => {
        let date = new Date(item?.asOfDate)  // 2009-11-10
        let month = date.toLocaleString("default", { month: "long" })
        month = month.toString().substring(0, 3)
        let year = date.getFullYear()
        year = year.toString().slice(-2)
        if (arrMonthYear.indexOf(month + "-" + year) == -1) {
          arrMonthYear.push(month + "-" + year)
          arrSumValue.push(item?.reviews)
        } else {
          arrSumValue[arrMonthYear.indexOf(month + "-" + year)] = arrSumValue[arrMonthYear.indexOf(month + "-" + year)] + item?.reviews
        }
      })
      arrSumValue = arrSumValue.reverse()
      let totalMonth = 12
      if (arrMonthYear?.length < 12) {
        totalMonth = arrMonthYear?.length
      }
      arrMonthYear = arrMonthYear.reverse()
      arrMonthYear = Array(totalMonth - 0).fill().map((item, indx) => { return arrMonthYear[indx] })
      arrSumValue = Array(totalMonth - 0).fill().map((item, indx) => { return arrSumValue[indx] })
      setState(
        {
          series: [{
            data: arrSumValue.reverse()
          }],
          options: {
            ...state?.options,
            tooltip: {
              ...state?.options?.tooltip,
              custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                return `<div class="${styles.ArrowBox}">` +
                  "<p>" + arrMonthYear[dataPointIndex] + "</p>" +
                  "<span>" + series[seriesIndex][dataPointIndex]?.toLocaleString() + "</span>" +
                  "</div>"
              },
            },
            xaxis: {
              categories:
                arrMonthYear.reverse()
            }
          },
        }
      )
    }
    if (finalData?.seller?.categories?.length > 0) {
      let donutChartLabels = []
      let donutChartDataSeries = []
      setDonutchartOptionscharts([])
      setDonutchartSeries([])
      orderBy(finalData?.seller?.categories, "productCountPct", "desc")?.map((item, index) => {
        // validating category name to remover characters like "-"
        if (item?.category?.name?.length > 2) {
          donutChartDataSeries.push(parseFloat(item?.productCountPct))
          donutChartLabels.push(item?.category?.name)
        }
      })
      setDonutchartOptionscharts({
        series: donutChartDataSeries,
        labels: donutChartLabels,
      })
      setDonutchartSeries(donutChartDataSeries)
    }
  }, [finalData, subscriptionDetails])

  const dispalychart = () => {
    if (state && state?.options && state?.series)
      return (
        <Chart key={state} options={state?.options} series={state?.series} type="bar" height={450} />
      )
  }

  function ButtonMoreDetailsClick() {
  }

  return (
    <>
      {!isSignedIn() || subscriptionDetails?.subscriptionData === null ?
        <Script
          id="Adsense-id"
          async="true"
          strategy="afterInteractive"
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1586268684877113"
        />
        : ""
      }
      <Meta key={finalData} pageName={`${finalData?.seller?.name ? finalData?.seller?.name : ""} |  Amazon Best Seller On Amazon ${(finalData?.seller?.domain?.name)} Marketplace | TrackSellers.com`}
        description={`${finalData?.seller?.name ? finalData?.seller?.name : ""} is a trusted seller on the Amazon ${(finalData?.seller?.domain?.name)} marketplace, offering ${((finalData?.seller?.categories && finalData?.seller?.categories[0]?.category?.name) ? oderbyCategories(finalData?.seller?.categories) : "")} from top brands like ${((finalData?.seller?.brands && finalData?.seller?.brands[0]?.brand) ? oderbyBrand(finalData?.seller?.brands) : "")} `}
        hrefLink={`https://www.tracksellers.com/sellers/${finalData?.seller?.domain?.code}/${finalData?.seller?.id.split("-")[1]}/${replaceUrlString(finalData?.seller?.name)}`}
      />
      <ContextProvider>
        <ProgressBar />
        <Box className={styles.DashboardMain}>
          <Container maxW="container.xl">
            <Flex direction="column" pt={{ base: "35px", sm: "30px", md: "30px", lg: "75px" }}>
              <Grid
                gridTemplateColumns={{
                  sm: "1fr",
                  md: "1fr",
                  lg: "1fr",
                }}
                gap="24px"
                mb="24px"
              >
                <Flex justifyContent="flex-end">
                  <NextLink href={`/sellers/by-domain/${code}`} passHref>
                    <Text cursor="pointer" color="#039be5">Amazon Top Sellers</Text>
                  </NextLink>
                </Flex>
                <Card className={styles.DashboardTitle} p="15px">
                  <CardBody>
                    <Flex direction={{ sm: "column", lg: "row" }} className={styles.DashboardFlex} alignItems={{ sm: "center", md: "center", lg: "center" }}>
                      <Box mb={{ sm: "15", md: "15", lg: "0" }} display="flex" flexDirection={{ sm: "column", md: "column", lg: "row" }}>
                        <IconBox className={styles.LogoContainer} marginRight={{ base: "auto", md: "auto", lg: "25px" }}
                          marginLeft={{ base: "auto", md: "auto", lg: "auto" }}>
                          <Image
                            src={logo}
                            alt="SellerLogo"
                            width="200px"
                            height="200px"
                            objectFit="contain"
                          />
                        </IconBox>
                        <Heading className={styles.SummaryHead} fontSize={{ base: "1.4rem", md: "1.4rem", lg: "1.8rem" }}>
                          {finalData?.seller?.name}
                        </Heading>
                      </Box>
                      <Box className={styles.SellerBtn}
                        flexDirection={{ base: "column", md: "column", lg: "row" }}
                        alignItems={{ base: "center", md: "center", lg: "flex-end" }}>
                        <Box width="100%" margin="auto" textAlign="center">
                          <NextLink href={`/seller-intelligence-report/${code}/${sellerId}`} passHref>
                            <Link>
                              <ButtonPrimary buttonName="Seller Intelligence Report" ButtonClick={ButtonMoreDetailsClick} />
                            </Link>
                          </NextLink>
                        </Box>
                        <Button
                          w="100%"
                          fontSize="0.875rem"
                          fontWeight="500"
                          padding={{ base: "0.5rem 1.2rem", md: "1rem 2rem", lg: "1rem 2rem" }}
                          _hover={{
                            bg: "#039be5"
                          }}
                          type="submit" p="1rem 2rem" bg="#039be5" mt={{ base: "10px", md: "10px", lg: "0px" }} ml={{ base: "0", md: "0", lg: "10px" }} color="#fff" borderRadius="50px"
                          onClick={(event) => { refresh(finalData?.seller?.domain?.code, finalData?.seller?.id) }}
                          isDisabled={!progressLoad && !loading ? false : true}
                        >
                          REFRESH DATA
                          <RepeatIcon marginLeft={2} />
                        </Button>
                      </Box>
                    </Flex>
                  </CardBody>
                </Card>
              </Grid>
              <Grid gridTemplateColumns={{ sm: "1fr", lg: "1fr" }} gap="24px" mb="24px">
                <Card minH="500px" key={loading} p="0px">
                  <CardHeader className={styles.SummaryCardHeader}>
                    <Flex direction="column" >
                      <Heading color="#243e63" fontSize={{ base: "1.4rem", md: "1.4rem", lg: "1.8rem" }} className={styles.SummaryHeader}>
                        Summary
                      </Heading>
                    </Flex>
                  </CardHeader>
                  <CardBody className={styles.SummaryCardBody} key={loading}>
                    {
                      loading == true ? <SkeletonTable numberOfTd={2} /> :
                        <Table color="gray.500" mb="0px" size="sm">
                          <Tbody>
                            {
                              summery?.map((item, index) => {
                                return (
                                  <Tr key={index}>
                                    <Td
                                      pt="5px"
                                      pb="5px"
                                      width="260px"
                                      lineHeight="normal"
                                      _first={{ fontWeight: "500", color: "#243e63" }}
                                      fontSize={{ sm: "16px" }}
                                      justifyContent="space-between"
                                    >
                                      {item?.colFirst}
                                    </Td>
                                    <Td pl="0px"
                                      pt="5px"
                                      pb="5px"
                                      lineHeight="normal"
                                      _first={{ fontWeight: "500", color: "#243e63" }}
                                      fontSize={{ sm: "16px" }}
                                      justifyContent="space-between"
                                    >
                                      {
                                        item?.colFirst == "Top Categories"
                                          ? item?.colSecond?.map((x, y) => {
                                            return (
                                              <Box
                                                display="inline"
                                                key={y}
                                              >
                                                {
                                                  y > 0 && <span>,&nbsp;</span>
                                                }
                                                <NextLink href={`/sellers/by-category/${router?.query?.id}/${x?.id}/${replaceUrlString(x?.name)}`} passHref>
                                                  <Link
                                                    _hover={{
                                                      color: "#243e63",
                                                      bg: "#bbeffd",
                                                      borderBottom: "1px solid rgba(0,0,0,0.2)"
                                                    }}
                                                    color="#039be5"

                                                  >
                                                    {x?.name}
                                                  </Link>
                                                </NextLink>
                                              </Box>
                                            )
                                          })
                                          : item?.colSecond
                                      }
                                    </Td>
                                  </Tr>
                                )
                              })
                            }
                          </Tbody>
                        </Table>
                    }
                  </CardBody>
                </Card>
              </Grid>
              <Grid
                gridTemplateColumns={{ sm: "1fr", md: "1fr 1fr", lg: "1fr 1fr 1fr 1fr" }}
                templateRows="1fr"
                gap="24px"
                mb="24px"
              >
                <Card bg="#fff">
                  <CardBody>
                    <Flex className={styles.RankCardFlex}>
                      <Flex justify="space-between" direction="row" alignItems="center">
                        <Text className={styles.RankCardText}>
                          Rank (12m)
                        </Text>
                        <Text className={styles.RankCardSubText}>
                          {finalData?.seller?.stats?.rank12m ? finalData?.seller?.stats?.rank12m?.toLocaleString() : ""}
                        </Text>
                      </Flex>
                      <Flex direction="row" justifyContent="space-between">
                        <IconBox className={styles.RankCardIconBox}>
                          <Image src={rankImg} alt="rank"></Image>
                        </IconBox>
                        <Flex direction="column" alignItems="flex-end">
                          <Text className={styles.RankFlexIconText}>
                            Rank Lifetime
                          </Text>
                          <Text className={styles.RankFlexIconSubText}>
                            {finalData?.seller?.stats?.rankLifetime ? finalData?.seller?.stats?.rankLifetime?.toLocaleString() : ""}
                          </Text>
                        </Flex>
                      </Flex>
                    </Flex>
                  </CardBody>
                </Card>
                <Card bg="#fff">
                  <CardBody>
                    <Flex className={styles.RankCardFlex}>
                      <Flex justify="space-between" direction="row" alignItems="center">
                        <Text className={styles.RankCardText}>
                          Reviews(12m)
                        </Text>
                        <Text className={styles.RankCardSubText}>
                          {finalData?.seller?.stats?.reviews12m ? finalData?.seller?.stats?.reviews12m?.toLocaleString() : ""}
                        </Text>
                      </Flex>
                      <Flex direction="row" justifyContent="space-between" alignItems="center">
                        <IconBox className={styles.RankCardIconBox}>
                          <Image src={reviewImg} alt="review"></Image>
                        </IconBox>
                        <Flex direction="column" alignItems="flex-end">
                          <Text className={styles.RankFlexIconText}>
                            Reviews Lifetime
                          </Text>
                          <Text className={styles.RankFlexIconSubText}>
                            {finalData?.seller?.reviewsLifetime ? finalData?.seller?.reviewsLifetime?.toLocaleString() : ""}
                          </Text>
                        </Flex>
                      </Flex>
                    </Flex>
                  </CardBody>
                </Card>
                <Card bg="#fff">
                  <CardBody>
                    <Flex className={styles.RankCardFlex}>
                      <Flex justify="space-between" direction="row" alignItems="center">
                        <Text className={styles.RankCardText}>
                          Rating (12m)
                        </Text>
                        <Text className={styles.RankCardSubText}>
                          {finalData?.seller?.stats?.rating12m ? finalData?.seller?.stats?.rating12m + "%" : ""}
                        </Text>
                      </Flex>
                      <Flex direction="column" alignItems="flex-start">
                        <IconBox className={styles.RankCardIconBox}>
                          <Image src={starImg} alt="rating"></Image>
                        </IconBox>
                      </Flex>
                    </Flex>
                  </CardBody>
                </Card>
                <Card bg="#fff">
                  <CardBody>
                    <Flex className={styles.RankCardFlex}>
                      <Flex justify="space-between" direction="row" alignItems="center">
                        <Text className={styles.RankCardText}>
                          Listings
                        </Text>
                        <Text className={styles.RankCardSubText}>
                          {finalData?.seller?.listings ? finalData?.seller?.listings?.toLocaleString() : ""}
                        </Text>
                      </Flex>
                      <Flex direction="row" justifyContent="space-between">
                        <IconBox className={styles.RankCardIconBox}>
                          <Image src={listingImg} alt="score"></Image>
                        </IconBox>
                        <Flex direction="column" alignItems="flex-end">
                          <Text className={styles.RankFlexIconText}>
                            As Of
                          </Text>
                          <Text className={styles.RankFlexIconSubText}>
                            {finalData?.seller?.listingsAsOfDate ? moment(finalData?.seller?.listingsAsOfDate)?.format("MMM-DD,YYYY") : ""}
                          </Text>
                        </Flex>
                      </Flex>
                    </Flex>
                  </CardBody>
                </Card>
              </Grid>
              {
                finalData?.seller?.timeSeries?.length > 0
                  ?
                  <Card p="0px"
                    className={styles.reviewCard}
                    gridColumn={{ md: "1 / 3", lg: "1 / 4" }}
                    mb="24px"
                  >
                    <CardHeader className={styles.ReviewCardHeader}>
                      <Flex className={styles.ReviewCardFlex}>
                        <Flex align="center">
                          <Flex direction="column">
                            <Heading fontSize={{ base: "1.4rem", md: "1.4rem", lg: "1.8rem" }} className={styles.ReviewCardFlexHeading} >
                              Reviews History
                            </Heading>
                          </Flex>
                        </Flex>
                      </Flex>
                    </CardHeader>
                    <CardBody key={state}>
                      <Box w="100%">
                        {dispalychart()}
                      </Box>
                    </CardBody>
                  </Card>
                  :
                  <Card p="0px"
                    className={styles.reviewCard}
                    gridColumn={{ md: "1 / 3", lg: "1 / 4" }}
                    mb="24px"
                    h="30%"
                  >
                    <CardHeader className={styles.ReviewCardHeader}>
                      <Flex className={styles.ReviewCardFlex}>
                        <Flex align="center">
                          <Flex direction="column">
                            <Heading fontSize={{ base: "1.4rem", md: "1.4rem", lg: "1.8rem" }} className={styles.ReviewCardFlexHeading} >
                              Reviews History
                            </Heading>
                          </Flex>
                        </Flex>
                      </Flex>
                    </CardHeader>
                    <CardBody>
                      <Box w="100%" textAlign="center" mt="5%" mb="5%">
                        <Text
                          padding={{ base: "0", md: "0 2rem", lg: "0 2rem" }}
                          textAlign="center" color="#243e63" fontSize={{ base: "1rem", md: "1rem", lg: "1.1rem" }}>
                          Feature available only for paid users. Please upgrade to access all the metrics on 5M Amazon sellers worldwide
                        </Text>
                        <Box width="100%" margin="15px 0 auto" textAlign="center">
                          <NextLink href={"/pricing"} passHref>
                            <Link>
                              <ButtonPrimary buttonName="Pricing" ButtonClick={ButtonMoreDetailsClick} />
                            </Link>
                          </NextLink>
                        </Box>
                      </Box>
                    </CardBody>
                  </Card>
              }
              <Grid
                gridTemplateColumns={{
                  sm: "1fr",
                  md: "1fr 1fr",
                  lg: "1fr 1fr",
                }}
                gap="24px"
                mb="24px"
              >
                {
                  finalData?.seller?.categories?.length > 0 && (isSignedIn() && subscriptionFeatures === "Yes")
                    ?
                    <Card p="0px">
                      <CardHeader className={styles.BrandCardHeader}>
                        <Flex direction="row" justifyContent="space-between" alignItems="center" flex={1}>
                          <Heading
                            fontSize={{ base: "1.4rem", md: "1.4rem", lg: "1.8rem" }}
                            className={styles.BrandCardHeading}
                            onClick={(event) => {
                            }}
                          >
                            Listings By Category
                          </Heading>
                          {
                            donutChartTable === true
                              ? <Box>
                                <IconButton
                                  icon={<CloseIcon />}
                                  bg="#fff"
                                  onClick={() => { setDonutChartTable(false) }}
                                />
                              </Box>
                              : null
                          }
                        </Flex>
                      </CardHeader>
                      {finalData?.seller?.categories?.length > 0
                        ?
                        <CardBody>
                          {
                            donutChartTable == false
                              ?
                              <Box p="15px" w="100%" minH={{ base: "400px", sm: "400px", lg: "300px" }}
                                maxH={{ base: "450px", sm: "450px", lg: "350px" }}>
                                {
                                  loading == true
                                    ? <SkeletonTable numberOfTd={2} />
                                    :
                                    <>
                                      <DonutChart
                                        chartData={donutchartSeries}
                                        chartOptions={donutchartOptionscharts}
                                        key={loading}
                                      />
                                      <Box display="flex" justifyContent="flex-end">
                                        <IconButton
                                          icon={<HamburgerIcon />}
                                          className={styles.ChartToTableBtn}
                                          onClick={() => { setDonutChartTable(true) }}
                                        />
                                      </Box>
                                    </>
                                }
                              </Box>
                              :
                              <Box flex="1" h="450px" overflow="auto">
                                {
                                  loading == true
                                    ? <SkeletonTable numberOfTd={2} />
                                    : <Table variant="simple" color="gray.500" mb="24px">
                                      <Thead>
                                        <Tr>
                                          <Td
                                            pl="15px"
                                            pb="15px"
                                            pt="10px"
                                            fontWeight="600"
                                            color="#243e63"
                                          >
                                            Category
                                          </Td>
                                          <Td
                                            pl="0px"
                                            pb="15px"
                                            pt="10px"
                                            fontWeight="600"
                                            color="#243e63"
                                          >
                                            Listings
                                          </Td>
                                        </Tr>
                                      </Thead>
                                      <Tbody>
                                        {
                                          orderBy(finalData?.seller?.categories, "productCountPct", "desc")?.map((item, index) => {
                                            // validating category name to remover characters like "-"
                                            if (item?.category?.name?.length > 2) {
                                              return (
                                                <Tr key={index}>
                                                  <Td pl="15px"
                                                    pt="5px"
                                                    pb="5px"
                                                    lineHeight="30px"
                                                    fontSize={{ sm: "16px" }}
                                                    justifyContent="space-between"
                                                  >
                                                    {item?.category?.name}
                                                  </Td>
                                                  <Td pl="0px"
                                                    pt="5px"
                                                    pb="5px"
                                                    lineHeight="20px"
                                                    fontSize={{ sm: "16px" }}
                                                    justifyContent="space-between"
                                                  >
                                                    {(item?.productCountPct * 100).toFixed(1) + "%"}
                                                  </Td>
                                                </Tr>
                                              )
                                            }
                                          })
                                        }
                                      </Tbody>
                                    </Table>
                                }
                              </Box>
                          }
                        </CardBody>
                        : null
                      }
                    </Card>
                    :
                    <Card p="0px">
                      <CardHeader className={styles.BrandCardHeader}>
                        <Flex direction="row" justifyContent="space-between" alignItems="center" flex={1}>
                          <Heading
                            fontSize={{ base: "1.4rem", md: "1.4rem", lg: "1.8rem" }}
                            className={styles.BrandCardHeading}
                            onClick={(event) => {
                            }}
                          >
                            Listings By Category
                          </Heading>
                          {
                            donutChartTable === true
                              ? <Box>
                                <IconButton
                                  icon={<CloseIcon />}
                                  bg="#fff"
                                  onClick={() => { setDonutChartTable(false) }}
                                />
                              </Box>
                              : null
                          }
                        </Flex>
                      </CardHeader>
                      <CardBody h="100%">
                        <Box w="100%" textAlign="center" mt="auto" mb="auto">
                          <Text
                            padding={{ base: "0", md: "0 2rem", lg: "0 2rem" }}
                            textAlign="center" color="#243e63" fontSize={{ base: "1rem", md: "1rem", lg: "1.1rem" }}>
                            Feature available only for paid users. Please upgrade to access all the metrics on 5M Amazon sellers worldwide
                          </Text>
                          <Box width="100%" margin="15px 0 auto" textAlign="center">
                            <NextLink href={"/pricing"} passHref>
                              <Link>
                                <ButtonPrimary buttonName="Pricing" ButtonClick={ButtonMoreDetailsClick} />
                              </Link>
                            </NextLink>
                          </Box>
                        </Box>
                      </CardBody>
                    </Card>
                }
                {
                  finalData?.seller?.brands?.length > 0 && (isSignedIn() && subscriptionFeatures === "Yes")
                    ?
                    <Card
                      bgPosition="10%"
                      p="0px"
                      h={{ sm: "100%", xl: "100%" }}
                    >
                      <CardHeader borderBottom="2px solid #EDF2F7">
                        <Flex
                          direction="column"
                          className={styles.BrandListFlex}
                        >
                          <Flex justify="space-between" alignItems="center">
                            <Heading className={styles.SummaryCardHeader} color="#243e63" fontSize={{ base: "1.4rem", md: "1.4rem", lg: "1.8rem" }}>
                              Listings By Brands
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={`https://www.${finalData?.seller?.domain?.amazonUrl}/s?me=${router.query.sellerId[0]}&pickerToList=brandtextbin`}
                              >
                                <ExternalLinkIcon
                                  fontSize={{
                                    base: "1.2rem",
                                    md: "1.2rem",
                                    lg: "1.2rem",
                                  }}
                                  ml="10px"
                                  color="#039be5"
                                  className={styles.CardPointIcons}
                                ></ExternalLinkIcon>
                              </a>
                            </Heading>
                            <Icon
                              as={RiMastercardFill}
                              className={styles.BrandListIcon}
                            />
                          </Flex>
                        </Flex>
                      </CardHeader>
                      <CardBody w="100%">
                        {
                          loading == true
                            ? <SkeletonTable numberOfTd={2} />
                            : <Table variant="simple" color="gray.500" mb="24px">
                              <Tbody>
                                {
                                  orderBy(finalData?.seller?.brands, "productCountPct", "desc")?.map((item, index) => {
                                    return (
                                      <Tr key={index}>
                                        <Td pl="15px"
                                          pt="5px"
                                          pb="5px"
                                          lineHeight="30px"
                                          _first={{ fontWeight: "500", color: "#039be5", cursor: "pointer" }}
                                          fontSize={{ sm: "16px" }}
                                          justifyContent="space-between"
                                        >
                                          <a
                                            target="_blank"
                                            rel="noreferrer"
                                            href={`https://www.${finalData?.seller?.domain?.amazonUrl}/s?me=${router.query.sellerId[0]}&rh=p_4%3A${item?.brand}`}
                                          >
                                            {item?.brand}
                                          </a>
                                        </Td>
                                        <Td pl="0px"
                                          pt="5px"
                                          pb="5px"
                                          lineHeight="20px"
                                          _first={{ fontWeight: "500", color: "#243e63" }}
                                          fontSize={{ sm: "16px" }}
                                          justifyContent="space-between"
                                        >
                                          {(item?.productCountPct * 100).toFixed(1) + "%"}
                                        </Td>
                                      </Tr>
                                    )
                                  })
                                }
                              </Tbody>
                            </Table>
                        }
                      </CardBody>
                    </Card>
                    :
                    <Card
                      bgPosition="10%"
                      p="0px"
                      h={{ sm: "100%", xl: "100%" }}
                    >
                      <CardHeader borderBottom="2px solid #EDF2F7">
                        <Flex
                          direction="column"
                          className={styles.BrandListFlex}
                        >
                          <Flex justify="space-between" alignItems="center">
                            <Heading className={styles.SummaryCardHeader} color="#243e63" fontSize={{ base: "1.4rem", md: "1.4rem", lg: "1.8rem" }}>
                              Listings By Brands
                            </Heading>
                            <Icon
                              as={RiMastercardFill}
                              className={styles.BrandListIcon}
                            />
                          </Flex>
                        </Flex>
                      </CardHeader>
                      <CardBody w="100%" h="100%">
                        <Box mt="5%" mb="5%" textAlign="center">
                          <Text
                            padding={{ base: "0", md: "0 2rem", lg: "0 2rem" }}
                            textAlign="center" color="#243e63" fontSize={{ base: "1rem", md: "1rem", lg: "1.1rem" }}>
                            Feature available only for paid users. Please upgrade to access all the metrics on 5M Amazon sellers worldwide
                          </Text>
                          <Box width="100%" margin="15px 0 auto" textAlign="center">
                            <NextLink href={"/pricing"} passHref>
                              <Link>
                                <ButtonPrimary buttonName="Pricing" ButtonClick={ButtonMoreDetailsClick} />
                              </Link>
                            </NextLink>
                          </Box>
                        </Box>
                      </CardBody>
                    </Card>
                }
              </Grid>
              <Grid
                gridTemplateColumns={{
                  sm: "1fr",
                  md: "1fr",
                  lg: "1fr",
                }}
                gap="24px"
                mb="24px"
              >
                {
                  finalData?.seller?.similarSellers?.length > 0 && isSignedIn()
                    ?
                    <Card p="0px">
                      <CardHeader className={styles.BrandCardHeader}>
                        <Flex direction="column">
                          <Heading fontSize={{ base: "1.4rem", md: "1.4rem", lg: "1.8rem" }}>
                            <span>{finalData?.seller?.name ? "Top Competitors of " : ""}</span>
                            <span className={styles.HeadingColorStyle}>
                              {finalData?.seller?.name ? finalData?.seller?.name : ""}
                            </span>
                          </Heading>
                        </Flex>
                      </CardHeader>
                      <CardBody h="100%">
                        <Box w="100%">
                          <Flex className={styles.FlexMain}>
                            {
                              finalData?.seller?.similarSellers?.map((item, index) => {
                                return (
                                  <Card className={styles.ProductBox} key={index} cursor="pointer" onClick={() => routePage(item?.similarSeller?.id, item?.similarSeller?.name, item?.similarSeller?.domain?.code)}>

                                    <Box className={styles.IcontextBox}>

                                      <Box className={styles.CircleIcon}>
                                        <Image src={item?.similarSeller?.info?.logoImage ? "https://images-na.ssl-images-amazon.com/images/I/" + item?.similarSeller?.info?.logoImage : defaultImage} alt="flag" layout="fill" className={styles.ProductImage}></Image>
                                      </Box>

                                      <Text className={styles.ProductText}>{item?.similarSeller?.name}</Text>
                                    </Box>
                                    <Box className={styles.BottomWrapper}>
                                      <Box className={styles.IcontextWrapper}>
                                        <Box className={styles.IconIMG}>
                                          <Image src={reviewImg} alt="avatar"></Image></Box>
                                        <Text className={styles.IcontextContent}>
                                          {item?.similarSeller?.stats?.reviews12m?.toLocaleString()}
                                        </Text>
                                      </Box>

                                      <Box className={styles.IconrightextWrapper}>
                                        <Box className={styles.IconIMG}>
                                          <Image src={rankImg} alt="avatar"></Image></Box>

                                        {revenueCount(item?.similarSeller?.stats?.rank12m, true)}

                                      </Box>
                                    </Box>
                                  </Card>
                                )
                              })
                            }
                          </Flex>
                        </Box>
                      </CardBody>
                    </Card>
                    : !isSignedIn() || !subscriptionDetails?.subscriptionExists ?
                      <Card p="0px">
                        <CardHeader className={styles.BrandCardHeader}>
                          <Flex direction="column">
                            <Heading fontSize={{ base: "1.4rem", md: "1.4rem", lg: "1.8rem" }}>
                              <span>{finalData?.seller?.name ? "Top Competitors of " : ""}</span>
                              <span className={styles.HeadingColorStyle}>
                                {finalData?.seller?.name ? finalData?.seller?.name : ""}
                              </span>
                            </Heading>
                          </Flex>
                        </CardHeader>
                        <CardBody>
                          <Box w="100%" textAlign="center" mt="5%" mb="5%">
                            <Text
                              padding={{ base: "0", md: "0 2rem", lg: "0 2rem" }}
                              textAlign="center" color="#243e63" fontSize={{ base: "1rem", md: "1rem", lg: "1.1rem" }}>
                              Feature available only for paid users. Please upgrade to access all the metrics on 5M Amazon sellers worldwide
                            </Text>
                            <Box width="100%" margin="15px 0 auto" textAlign="center">
                              <NextLink href={"/pricing"} passHref>
                                <Link>
                                  <ButtonPrimary buttonName="Pricing" ButtonClick={ButtonMoreDetailsClick} />
                                </Link>
                              </NextLink>
                            </Box>
                          </Box>
                        </CardBody>
                      </Card>
                      : null
                }
              </Grid>
              <Grid
                gridTemplateColumns={{
                  sm: "1fr",
                  md: "1fr",
                  lg: "1fr",
                }}
                gap="24px"
                mb="24px"
              >
                <Card p="0px">
                  <CardHeader className={styles.BrandCardHeader}>
                    <Flex direction={{ sm: "column", lg: "row" }} justify="space-between" w="100%" alignItems="flex-start">
                      <Heading color="#243e63" fontSize={{ base: "1.4rem", md: "1.4rem", lg: "1.8rem" }}>
                        Products
                      </Heading>
                    </Flex>
                  </CardHeader>
                  <CardBody p="15px">
                    <Box display="flex" flexDirection="column">
                      <span>Coming soon... </span>
                      {
                        finalData?.seller?.domain?.amazonUrl
                          ? <h1>
                            {"Seller's storefront on Amazon can be found"}

                            <span className={styles.textLink}>
                              {" "}
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={`https://www.${finalData?.seller?.domain?.amazonUrl}/s?me=${router.query.sellerId[0]}`}
                              >
                                here
                              </a>
                            </span>
                          </h1>
                          : null
                      }
                    </Box>
                  </CardBody>
                </Card>
              </Grid>
            </Flex>
            {
              finalData?.seller ?
                <Box width="100%" margin="auto" textAlign="center">
                  <NextLink href={`/seller-intelligence-report/${code}/${sellerId}`} passHref>
                    <Link>
                      <ButtonPrimary buttonName="Seller Intelligence Report" ButtonClick={ButtonMoreDetailsClick} />
                    </Link>
                  </NextLink>
                </Box>
                : null
            }

          </Container>
          <Modal isCentered
            closeOnOverlayClick={false}
            isOpen={signedIn}
            onClose={signedInModalClose}
            size={"md"}
            height="460px"
          >
            <ModalOverlay />
            <ModalContent p="15px" margin="15px" minH={{ base: "180px", md: "180px", xl: "180px", lg: "180px" }}>
              <ModalHeader p="0px">
                <Flex fontSize={{ base: "18px", md: "24px", lg: "24px" }} color="#243e63">
                  {/* <Text>{heading}</Text> */}
                  <Text color="rgb(3, 155, 229)" fontWeight="300">
                    TrackSellers.com
                  </Text>
                </Flex>
              </ModalHeader>
              <ModalCloseButton top="1rem" color="#718096" />
              <ModalBody pt="15px" pb="0px" w="100%">
                <Text
                  padding={{ base: "0", md: "0 2rem", lg: "0 2rem" }}
                  textAlign="center" color="#243e63" fontSize={{ base: "1rem", md: "1rem", lg: "1.1rem" }}>
                  This feature is available only for paid users
                </Text>
                <Box width="100%" margin="15px 0 auto" textAlign="center">
                  <NextLink href={"/pricing"} passHref>
                    <Link>
                      <ButtonPrimary buttonName="Pricing Plans" ButtonClick={ButtonMoreDetailsClick} />
                    </Link>
                  </NextLink>
                </Box>
              </ModalBody>
            </ModalContent>
          </Modal >
        </Box>
      </ContextProvider>
    </>
  )
}


export const getServerSideProps = async (context) => {
  let sellerId = 0
  if (context?.params?.sellerId && context?.params?.sellerId.length > 0) {
    sellerId = context?.params?.sellerId[0]
  }

  // For SEO https://tracksellers.atlassian.net/browse/SEO-10
  const slug = context?.params?.sellerId?.[1]
  if (slug && slug !== slug.toLowerCase()) {
    return {
      redirect: {
        destination: `/sellers/${context?.params?.id}/${sellerId}/${slug.toLowerCase()}`,
        statusCode: 301,
      },
    }
  }

  let invalidDomin = true
  let code = ""
  let name = ""
  let sellerData

  try {
    const res = await Client.query({
      query: SELLER_DETAILS_AND_ALL_DOMAIN,
      variables: {
        domainCode: context?.params?.id,
        sellerId: context?.params?.sellerId[0]
      },
      fetchPolicy: "no-cache",
      context: {
        "nextReqContext": context
      }
    })
    res?.data?.allDomains?.map((item, index) => {
      if (item?.code === context?.params?.id) {
        code = item?.code
        name = item?.name
        invalidDomin = false
        sellerData = res?.data
      }
    })
  } catch (error) {
    return {
      props: {}
    }
  }
  if (invalidDomin || code == null || code == "" || code == undefined) {
    return {
      notFound: true,
      props: {},
    }
  } else {
    return {
      props:
      {
        sellerId: sellerId,
        code: code,
        name: name,
        data: sellerData
      }
    }
  }
}